<template>
  <div class="upload-page">
    <ToolBar></ToolBar>
    <div class="editor-wrapper" v-if="!this.designId">
      <UploaderBox class="upload-widget-wrapper" @upload="onUpload" @error="onError" :extra="uploadExtra"/>
      <SideMenu class="side-menu d-none d-lg-block"></SideMenu>
    </div>
    <FixedMenu></FixedMenu>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import {expanded, compressed} from '@/lib/selectedProduct';

  import UploaderBox from './UploaderBox.vue';
  import SideMenu from './SideMenu.vue';
  import ToolBar from './PseudoToolBar.vue';
  import FixedMenu from './FixedMenu.vue';

  import {uploadPageVisited, uploadedFileSuccess, uploadedFileError} from '@/lib/track/events';

  export default {
    props: ['selectedInfo', 'designId'],
    components: {UploaderBox, SideMenu, ToolBar, FixedMenu},
    async created(){
      if (this.designId) {
        await this.setCurrentDesignId(this.designId);
        this.startOrder({destination: '/cart'});
      }
    },
    async mounted() {
      if (this.selectedInfo === 'default') {
        await this.loadDefaultProductInfo();
        let selectedInfo = compressed(this.defaultProductSelector);
        this.$router.replace({name: 'Upload', params: {selectedInfo, designId: this.designId}});
      }
      uploadPageVisited();
    },
    computed: {
      ...mapGetters(['design', 'defaultProductSelector']),
      uploadExtra() {
        let p = expanded(this.selectedInfo);
        return {force_two_pages: !!(p[2] && !p[1])};
      }
    },
    methods: {
      ...mapActions(['setDesign', 'addLineFromProductSelector', 'setCurrentDesignId', 'dropSecondPageFromDesign', 'showEditorMessage', 'loadDefaultProductInfo']),
      async onUpload(event) {
        uploadedFileSuccess();
        event.preventDefault();
        let {design} = event;
        this.setDesign(design);
        return this.startOrder();
      },
      async onError(event) {
        uploadedFileError(event);
      },
      async startOrder({destination}={}) {
        await this.addLineFromProductSelector(this.selectedInfo);
        this.$router.push(destination || {name: 'Editor', params: {id: this.design.id}});
      }
    }
  }
</script>

<style lang="scss" scoped>
.editor-wrapper{
  display:flex;
  min-width:504px;
  max-width:840px;
  margin: 0 auto;
}

@media (max-width: 600px) {
  .upload-page{
    height: 100vh;
  }
  .editor-wrapper{
    display:block;
    min-width:100%;
    max-width:100%;
    padding-top:0;
    margin: 0 auto;
  }
}

.upload-widget-wrapper {
  margin: 155px 54px 0 54px;
}
@media (max-width: 600px) {
  .upload-widget-wrapper {
    margin: 100px auto 0 auto;
  }
}

.side-menu {
  margin-top: 155px;
}
</style>




// WEBPACK FOOTER //
// src/components/pages/upload/Upload.vue